module.exports = __webpack_public_path__ + "images/emoji/package.2f2ebfb8f4d341f72489.png";